/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-07-04 22:56:10
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-08 00:13:26
 * @FilePath: /ack-slh-frontend/src/components/Antd/Form/index.tsx
 */
import { Form } from 'antd';
import css from './css.module.less';
import React from 'react';
import { get } from 'lodash';

const _Form = (props: any) => {
  const { children, ...rest } = props;
  return <Form {...rest}>{children}</Form>;
};
const _FormItem = (props: any) => {
  const { children, className, ...rest } = props;
  return (
    <Form.Item className={`${css.item} ${className || ''}`} {...rest}>
      {children}
    </Form.Item>
  );
};

const _FormItemShouldUpdate = (props: any) => {
  const { dependencies: compareArr, childGenerate } = props;
  return (
    <_FormItem
      shouldUpdate={(p, c) => {
        const arr = (compareArr || []).map((i) => {
          const pV = get(p, i);
          const cV = get(c, i);
          return pV === cV;
        });
        if (arr.length === 0) {
          return true;
        }
        const isDiff = arr.filter((i) => !i).length > 0;
        if (isDiff) {
          return true;
        }
        return false;
      }}>
      {(record) => {
        if (childGenerate) return childGenerate(record);
        return null;
      }}
    </_FormItem>
  );
};
_Form.ErrorList = Form.ErrorList;
_Form.Item = _FormItem;
_Form.useForm = Form.useForm;
_Form.List = Form.List;
_Form.ShouldUpdate = _FormItemShouldUpdate;
export default _Form;
